import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { UserPOS } from '../actions/actions.types'

type UserPosState = ApplicationState['userPOS']

function userPOSReducer(state: UserPosState = null, action: IAction): UserPosState {
	switch (action.type) {
		case UserPOS.GetUserPOS.SUCCESS:
			return action.payload
	}
	return state
}

export default userPOSReducer
